/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { SectionName } from "../../atoms/section-tag";
import { Headline } from "../../atoms/headline";
import { Subheadline } from "../../atoms/subheadline";
import { HeroImage } from "../../atoms/hero-image";
import { Authors } from "../../atoms/author";
import { ImageCaption } from "../../atoms/image-caption";
import { isDesktopSizeViewport } from "../../../utils";
import { SaveButton } from "../../molecules/save-button";
// import assetify from "@quintype/framework/assetify";
import { socialShareSupport } from "../../molecules/social-share";
import {
  checkIfStoryPublic,
  handleAccess,
  showStoryCards
} from "../../../access-type-utils";
import { AmazonPolly } from "../../molecules/amazon-polly/amazon-polly";
import PropTypes from "prop-types";
import "./text-story.m.css";
// import LoadingIcon from "../../../../assets/images/loader.svg";
import { connect, useSelector } from "react-redux";
import { GiftStoryButton } from "../../molecules/gift-story-button";

const TextSToryTempate = props => {
  const [deviceWidth, deviceWidthHandler] = useState("");
  useEffect(() => {
    deviceWidthHandler(!isDesktopSizeViewport() ? "full-width" : "");
  }, []);
  const hasActiveSubscription = useSelector(state =>
    get(state, ["fetchSubscription", "isActive"], null)
  );

  const isStoryPublic = checkIfStoryPublic(props.story);
  const story = isStoryPublic
    ? props.story
    : hasActiveSubscription
    ? props.story
    : props.newStory;

  const storyCards = get(story, ["cards"], []);

  return (
    <div styleName="text-story-wrapper">
      <div styleName="story-header">
        <div styleName="section">
          <SectionName story={story} />
        </div>
        <Headline story={story} isStoryPage />
        <Subheadline story={story} />
        <div>
          {isStoryPublic || hasActiveSubscription ? (
            <AmazonPolly story={story} />
          ) : null}
        </div>

        <div styleName="authorWithTimeStamp">
          <Authors story={story} />
          <span style={{ verticalAlign: "middle" }}>
            &nbsp;&nbsp;&nbsp;
            <SaveButton story={story} />
          </span>
          {!isStoryPublic && hasActiveSubscription ? (
            <GiftStoryButton story={story} />
          ) : null}
        </div>
      </div>
      <div className={`${deviceWidth}`}>
        <HeroImage story={story} />
      </div>
      <div>
        <ImageCaption story={story} />
      </div>
      <div styleName="story-content">
        <div styleName="social-share-icons">
          <div styleName="sticky">{socialShareSupport(story)}</div>
        </div>

        <div styleName="story-cards">
          {isStoryPublic
            ? showStoryCards(
                storyCards,
                props.config,
                story,
                hasActiveSubscription
              )
            : handleAccess(
                storyCards,
                props.config,
                story,
                hasActiveSubscription,
                null,
                props.member
              )}
        </div>
      </div>
    </div>
  );
};

TextSToryTempate.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  member: PropTypes.object,
  hasSubscription: PropTypes.bool
};
class TextStoryAccessWrapper extends React.Component {
  render() {
    return (
      <div>
        <TextSToryTempate {...this.props} />
      </div>
    );
  }
}

class TextStoryBase extends React.Component {
  render() {
    return <TextStoryAccessWrapper {...this.props} />;
  }
}

TextStoryBase.propTypes = {
  config: PropTypes.object
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {}),
  member: get(state, ["member"], null),
  hasSubscription: get(state, ["isSubscribedUser", "userHasSubscription"], null)
});

export const TextSTory = connect(mapStateToProps)(TextStoryBase);
TextSTory.propTypes = {
  story: PropTypes.shape({
    card: PropTypes.object
  })
};
